//具体的服务列表（所有的服务类型）
import { smartConnectionRouter } from './service/smartConnectionRouter.config'
import { salesTaskRouter } from './service/salesTaskRouter.config'
import { journeyTogetherRouter } from './service/journeyTogetherRouter.config'
import { chimelongTicketRouter } from './service/chimelongTicketRouter.config'
import { greenCloudRouter } from './service/greenCloudRouter.config'
import { fliggyRouter } from './service/fliggyRouter.config'
import { systemMovingAssistant } from './service/systemMovingAssistant.config'
import { fissionRedEnvelopeRouter } from './service/fissionRedEnvelopeRouter.config'
import { evaluateAndInformationRouter } from './service/evaluateAndInformationRouter.config'
import { ubrTickerRouter } from './service/ubrTickerRouter.config'
import { customizedTopicsRouter } from './service/customizedTopicsRouter.config'
import { erpDirectAssistantRouter } from './service/erpDirectAssistantRouter.config'
import { tiktokHelperRouter } from './service/tiktokHelperRouter.config'
import { changLianConnectionRouter } from './service/changLianConnectionRouter.config'
import { chaoMaiHelperRouter } from '@/config/module/service/chaoMaiHelperRouter.config'
import { electronicContractRouter } from './service/electronicContractRouter.config'
import { welfareMallRouter } from './service/welfareMallRouter.config'
import { zwyHotelRouter } from '@/config/module/service/zwyHotelRouter.config'
import { localDiscoveryManageRouter } from '@/config/module/service/localDiscoveryManageRouter.config'
import { citGroupTicketConnectionRouter } from '@/config/module/service/citGroupTicketConnectionRouter.config'
import { tuNiuConnectionRouter } from '@/config/module/service/tuNiuConnectionRouter.config'
import { sjlHotelRouter } from '@/config/module/service/sjlHotelRouter.config'
import { ylHotelRouter } from '@/config/module/service/ylHotelRouter.config'

export const serviceProviderList = [
  ...smartConnectionRouter,//智能物联服务相关路由
  ...salesTaskRouter,//营销任务服务相关路由
  ...journeyTogetherRouter,//旅程一起行服务相关路由
  ...chimelongTicketRouter,//长隆门票系统直连服务相关路由
  ...greenCloudRouter,//绿云PMS直连服务相关路由
  ...fliggyRouter,//飞猪直连服务相关路由
  ...systemMovingAssistant,//系统搬家助手服务相关路由
  ...fissionRedEnvelopeRouter,//裂变红包服务相关路由
  ...evaluateAndInformationRouter,//内容咨询与诚信评价服务相关路由
  ...ubrTickerRouter,
  ...customizedTopicsRouter,//定制专题相关内容
  ...erpDirectAssistantRouter,//昆仑ERP集团版对接助手
  ...tiktokHelperRouter,
  ...changLianConnectionRouter,//畅联直连
  ...chaoMaiHelperRouter,
  ...welfareMallRouter, // 福利商城
  ...electronicContractRouter, // 电子合同(12301)
  ...zwyHotelRouter,//自我游酒店直连
  ...localDiscoveryManageRouter,//位置发现管理
  ...citGroupTicketConnectionRouter,//中智游门票直连
  ...tuNiuConnectionRouter, // 途牛直连
  ...sjlHotelRouter, // 深捷旅酒店直连
  ...ylHotelRouter, // 艺龙酒店直连
  {
    path: '/service/complement/complementHelper',
    name: 'ComplementHelper',
    component: () => import('@/views/service/serviceProvider/complement/ComplementHelper'),
    meta: {
      title: '补差助手',
      keepAlive: true
    }
  },
  {
    path: '/service/insurance/insuranceList',
    name: 'InsuranceList',
    component: () => import('@/views/service/serviceProvider/insurance/InsuranceList'),
    meta: {
      title: '旅游保险',
      keepAlive: true
    }
  },
  {
    path: '/service/commission/commissionHelper',
    name: 'CommissionHelper',
    component: () => import('@/views/service/serviceProvider/commission/CommissionHelper'),
    meta: {
      title: '佣金助手',
      keepAlive: true
    }
  },
  {
    path: '/service/commission/commissionRule',
    name: 'CommissionRule',
    component: () => import('@/views/service/serviceProvider/commission/CommissionRule'),
    meta: {
      title: '佣金规则',
      keepAlive: true
    }
  },
  {
    path: '/service/commission/addCommissionRule',
    name: 'AddCommissionRule',
    component: () => import('@/views/service/serviceProvider/commission/AddCommissionRule'),
    meta: {
      title: '添加佣金规则',
      keepAlive: false
    }
  },
  {
    path: '/service/commission/calendar',
    name: 'CommissionCalendar',
    component: () => import('@/views/service/serviceProvider/commission/CommissionCalendar'),
    meta: {
      title: '设置佣金',
      keepAlive: false
    }
  },
  {
    path: '/service/coupon/list',
    name: 'CouponServiceList',
    component: () => import('@/views/service/serviceProvider/coupon/CouponServiceList'),
    meta: {
      title: '优惠券',
      keepAlive: true
    }
  },
  {
    path: '/service/coupon/rule',
    name: 'CouponRuleList',
    component: () => import('@/views/service/serviceProvider/coupon/CouponRuleList'),
    meta: {
      title: '规则列表',
      keepAlive: true
    }
  },
  {
    path: '/service/coupon/newRule',
    name: 'NewRule',
    component: () => import('@/views/service/serviceProvider/coupon/NewRule'),
    meta: {
      title: '新建优惠券规则',
      keepAlive: true
    }
  },
  {
    path: '/service/coupon/stats',
    name: 'CouponStatics',
    component: () => import('@/views/service/serviceProvider/coupon/CouponStatics'),
    meta: {
      title: '数据统计',
      keepAlive: true
    }
  },
  {
    path: '/service/coupon/new',
    name: 'NewCoupon',
    component: () => import('@/views/service/serviceProvider/coupon/NewCoupon'),
    meta: {
      title: '新建优惠券',
      keepAlive: true
    }
  },
  {
    path: '/service/onlineService/list',
    name: 'OnlineServiceList',
    component: () => import('@/views/service/serviceProvider/online/OnlineServiceList'),
    meta: {
      title: '在线客服',
      keepAlive: true
    }
  }, {
    path: '/service/onlineService/wechatManagement',
    name: 'WechatManagement',
    component: () => import('@/views/service/serviceProvider/online/WechatManagement'),
    meta: {
      title: '微信客服管理',
      keepAlive: true
    }
  },
  {
    path: '/service/onlineService/questionTemplate',
    name: 'QuestionTemplate',
    component: () => import('@/views/service/serviceProvider/online/QuestionTemplate'),
    meta: {
      title: '问答模板',
      keepAlive: true
    }
  },
  {
    path: '/service/link/list',
    name: 'ShotLinkList',
    component: () => import('@/views/service/serviceProvider/shotLink/ShotLinkList'),
    meta: {
      title: '短链列表',
      keepAlive: true
    }
  },
  {
    path: '/service/link/GenerateLink',
    name: 'GenerateLink',
    component: () => import('@/views/service/serviceProvider/shotLink/GenerateLink'),
    meta: {
      title: '短链服务',
      keepAlive: false
    }
  },
  {
    path: '/service/groupPurchase/list',
    name: 'GroupPurchaseList',
    component: () => import('@/views/service/serviceProvider/groupPurchase/GroupPurchaseList'),
    meta: {
      title: '团购服务',
      keepAlive: true
    }
  },
  {
    path: '/service/livePlayer/list',
    name: 'LivePlayerList',
    component: () => import('@/views/service/serviceProvider/livePlayer/LivePlayerList'),
    meta: {
      title: '小程序直播',
      keepAlive: true
    }
  },
  {
    path: '/service/messageNotification/list',
    name: 'MessageNotificationList',
    component: () => import('@/views/service/serviceProvider/messageNotification/MessageNotificationList'),
    meta: {
      title: '消息通知',
      keepAlive: true
    }
  },
  {
    path: '/service/messageNotification/noticTemplate',
    name: 'NoticTemplate',
    component: () => import('@/views/service/serviceProvider/messageNotification/NoticTemplate'),
    meta: {
      title: '通知模板',
      keepAlive: true
    }
  },
  {
    path: '/service/shopManager/list',
    name: 'ShopList',
    component: () => import('@/views/service/serviceProvider/shopManager/ShopList'),
    meta: {
      title: '门店管理',
      keepAlive: false
    }
  },
  {
    path: '/service/shopManager/addShop',
    name: 'AddShop',
    component: () => import('@/views/service/serviceProvider/shopManager/AddShop'),
    meta: {
      title: '添加门店',
      keepAlive: true
    }
  },
  {
    path: '/service/shopManager/clerkPerformance',
    name: 'ClerkPerformance',
    component: () => import('@/views/service/serviceProvider/shopManager/ClerkPerformance'),
    meta: {
      title: '店员业绩',
      keepAlive: true
    }
  },
  {
    path: '/service/shopManager/shopBindAccount',
    name: 'ShopBindAccount',
    component: () => import('@/views/service/serviceProvider/shopManager/ShopBindAccount'),
    meta: {
      title: '门店关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/erp/list',
    name: 'ErpConnectList',
    component: () => import('@/views/service/serviceProvider/erp/ErpConnectList'),
    meta: {
      title: 'ERP直连助手',
      keepAlive: false
    }
  },
  {
    path: '/service/erp/onlineDebugging',
    name: 'OnlineDebugging',
    component: () => import('@/views/service/serviceProvider/erp/OnlineDebugging'),
    meta: {
      title: '在线调试',
      keepAlive: true
    }
  },
  {
    path: '/service/erp/erpApiSetting',
    name: 'ErpApiSetting',
    component: () => import('@/views/service/serviceProvider/erp/ErpApiSetting'),
    meta: {
      title: 'Api配置',
      keepAlive: false
    }
  },
  {
    path: '/service/erp/erpConnectSetting',
    name: 'ErpConnectSetting',
    component: () => import('@/views/service/serviceProvider/erp/ErpConnectSetting'),
    meta: {
      title: '编辑',
      keepAlive: true
    }
  },
  // {
  //   path: '/service/erp/synchronizationSetting',   //预留功能
  //   name: 'SynchronizationSetting',
  //   component: () => import('@/views/service/serviceProvider/erp/synchronizationSetting'),
  //   meta: {
  //     title: "同步魔方设置列表",
  //     keepAlive: true
  //   }
  // },
  // {
  //   path: '/service/erp/synchronizationEdit',
  //   name: 'SynchronizationEdit',
  //   component: () => import('@/views/service/serviceProvider/erp/synchronizationEdit'),
  //   meta: {
  //     title: "编辑",
  //     keepAlive: false
  //   }
  // },

  {
    path: '/service/resourceControl/list',
    name: 'ResourceControlList',
    component: () => import('@/views/service/serviceProvider/resourceControl/ResourceControlList'),
    meta: {
      title: '资源控助手',
      keepAlive: true
    }
  },
  {
    path: '/service/resourceControl/bindProduct',
    name: 'ResourceControlList_BindProduct',
    component: () => import('@/views/service/serviceProvider/resourceControl/BindProduct'),
    meta: {
      title: '关联商品',
      keepAlive: false
    }
  },
  {
    path: '/service/resourceControl/refundRequest',
    name: 'RefundRequest',
    component: () => import('@/views/service/serviceProvider/resourceControl/RefundRequest'),
    meta: {
      title: '申请退款',
      keepAlive: false
    }
  },
  {
    path: '/service/resourceControl/changeOrder',
    name: 'ChangeOrder',
    component: () => import('@/views/service/serviceProvider/resourceControl/ChangeOrder'),
    meta: {
      title: '申请改单',
      keepAlive: false
    }
  },
  {
    path: '/service/resourceControl/batchOrder',
    name: 'BatchOrder',
    component: () => import('@/views/service/serviceProvider/resourceControl/BatchOrder'),
    meta: {
      title: '批量导单',
      keepAlive: true
    }
  },
  {
    path: '/service/resourceControl/commodityList',
    name: 'CommodityList',
    component: () => import('@/views/service/serviceProvider/resourceControl/CommodityList'),
    meta: {
      title: '商品列表',
      keepAlive: true
    }
  },
  {
    path: '/service/resourceControl/pushOrder',
    name: 'PushOrder',
    component: () => import('@/views/service/serviceProvider/resourceControl/PushOrder'),
    meta: {
      title: '推送订单',
      keepAlive: true
    }
  },
  {
    path: '/service/hotel/list',
    name: 'HotelDistributionList',
    component: () => import('@/views/service/serviceProvider/hotel/hotelDirectList'),
    meta: {
      title: '全国酒店直连',
      keepAlive: false
    }
  },
  {
    path: '/service/hotel/details',
    name: 'HotelMatchDetail',
    component: () => import('@/views/service/serviceProvider/hotel/HotelMatchDetail'),
    meta: {
      title: '匹配详情',
      keepAlive: true
    }
  },
  {
    path: '/service/hotel/handle',
    name: 'HotelhandleMatch',
    component: () => import('@/views/service/serviceProvider/hotel/HotelhandleMatch'),
    meta: {
      title: '手动匹配',
      keepAlive: true
    }
  },
  {
    path: '/service/poster/smartPoster',
    name: 'SmartPoster',
    component: () => import('@/views/service/serviceProvider/poster/SmartPoster'),
    meta: {
      title: '智能海报',
      keepAlive: true
    }
  },
  {
    path: '/service/poster/posterTemplate',
    name: 'PosterTemplate',
    component: () => import('@/views/service/serviceProvider/poster/PosterTemplate'),
    meta: {
      title: '海报模板',
      keepAlive: true
    }
  },
  {
    path: '/service/redEnvelopes/list',
    name: 'RedEnvelopes',
    component: () => import('@/views/service/serviceProvider/distribution/RedEnvelopes'),
    meta: {
      title: '红包',
      keepAlive: true
    }
  },
  {
    hidden: true, //不显示在菜单上
    path: '/service/redpacketSet',
    name: 'RedpacketSet',
    component: () => import('@/views/service/serviceProvider/distribution/RedpacketSet'),
    meta: {
      title: '设置规则',
      keepAlive: true,
      hideInMenu: true
    }
  },
  {
    path: '/service/styleManager/StyleService',
    name: 'StyleService',
    component: () => import('@/views/service/serviceProvider/styleManager/StyleService'),
    meta: {
      title: '百变专题',
      keepAlive: true
    }
  },
  {
    path: '/service/styleManager/ServiceThemeTemplate',
    name: 'ServiceThemeTemplate',
    component: () => import('@/views/service/serviceProvider/styleManager/ServiceThemeTemplate'),
    meta: {
      title: '专题模板',
      keepAlive: true
    }
  },
  {
    path: '/service/styleManager/AddThemeTemplate',
    name: 'AddThemeTemplate',
    component: () => import('@/views/service/serviceProvider/styleManager/AddThemeTemplate'),
    meta: {
      title: '制作专题',
      keepAlive: false
    }
  },
  {
    path: '/service/ticket/ticketConnection',
    name: 'TicketConnection',
    component: () => import('@/views/service/serviceProvider/ticket/TicketConnection'),
    meta: {
      title: '全国门票直连',
      keepAlive: false
    }
  },
  {
    path: '/service/ticket/matchDetails',
    name: 'MatchDetails',
    component: () => import('@/views/service/serviceProvider/ticket/MatchDetails'),
    meta: {
      title: '匹配详情',
      keepAlive: false
    }
  },
  {
    path: '/service/ticket/manualMatch',
    name: 'ManualMatch',
    component: () => import('@/views/service/serviceProvider/ticket/ManualMatch'),
    meta: {
      title: '手动匹配',
      keepAlive: false
    }
  },
  {
    path: '/service/zwy/list',
    name: 'ZwyConnection',
    component: () => import('@/views/service/serviceProvider/zwy/ZwyConnection'),
    meta: {
      title: '自我游抢购直连',
      keepAlive: true
    }
  },
  {
    path: '/service/zwy/direct',
    name: 'DirectOrder',
    component: () => import('@/views/service/serviceProvider/zwy/DirectOrder'),
    meta: {
      title: '订单直连',
      keepAlive: true
    }
  },
  {
    path: '/service/zwy/associatedAccount',
    name: 'AssociatedAccount',
    component: () => import('@/views/service/serviceProvider/zwy/AssociatedAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/yzh/list',
    name: 'YzhConnection',
    component: () => import('@/views/service/serviceProvider/yzh/YzhConnection'),
    meta: {
      title: '游智慧景区直连',
      keepAlive: true
    }
  },
  {
    path: '/service/yzh/orderConnection',
    name: 'OrderConnection',
    component: () => import('@/views/service/serviceProvider/yzh/OrderConnection'),
    meta: {
      title: '订单直连',
      keepAlive: true
    }
  },
  {
    path: '/service/yzh/addAccount',
    name: 'AddAccount',
    component: () => import('@/views/service/serviceProvider/yzh/AddAccount'),
    meta: {
      title: '添加关联账号',
      keepAlive: true
    }
  },
  {
    path: '/service/zyb/list',
    name: 'zhiyoubaoConnection',
    component: () => import('@/views/service/serviceProvider/zhiyoubao/ZhiyoubaoConnection'),
    meta: {
      title: '智游宝景区直连',
      keepAlive: true
    }
  },
  {
    path: '/service/zyb/orderConnection',
    name: 'zybOrderConnection',
    component: () => import('@/views/service/serviceProvider/zhiyoubao/OrderConnection'),
    meta: {
      title: '订单直连',
      keepAlive: true
    }
  },
  {
    path: '/service/zyb/relationAccount',
    name: 'zybRelationAccount',
    component: () => import('@/views/service/serviceProvider/zhiyoubao/RelationAccount'),
    meta: {
      title: '添加关联账号',
      keepAlive: true
    }
  },
  // 虚拟会员直连
  {
    path: '/service/virtual/list',
    name: 'VirtualConnection',
    component: () => import('@/views/service/serviceProvider/virtual/VirtualConnectionList'),
    meta: {
      title: '商品绑定',
      keepAlive: false
    }
  },
  // 虚拟会员直连
  {
    path: '/service/virtual/order',
    name: 'VirtualOrderConnection',
    component: () => import('@/views/service/serviceProvider/virtual/OrderConnection'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  // 虚拟会员直连
  {
    path: '/service/virtual/account',
    name: 'VirtualRelationAccount',
    component: () => import('@/views/service/serviceProvider/virtual/RelationAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/contract/contractManager',
    name: 'ContractManager',
    component: () => import('@/views/service/serviceProvider/contract/ContractManager'),
    meta: {
      maxStyle: true,
      title: '合同',
      keepAlive: true
    }
  },
  {
    path: '/service/contract/templateEditor',
    name: 'TemplateEditor',
    component: () => import('@/views/service/serviceProvider/contract/TemplateEditor'),
    meta: {
      maxStyle: true,
      title: '编辑模版',
      keepAlive: true
    }
  },
  {
    path: '/service/contract/contractCreator',
    name: 'ContractCreator',
    component: () => import('@/views/service/serviceProvider/contract/ContractCreator'),
    meta: {
      maxStyle: true,
      title: '创建合同',
      keepAlive: true
    }
  },
  {
    path: '/service/recommendation/list',
    name: 'RelatedRecommendation',
    component: () => import('@/views/service/serviceProvider/recommendation/RelatedRecommendation'),
    meta: {
      title: '关联推荐',
      keepAlive: true
    }
  },
  {
    path: '/service/fans/setting',
    name: 'FansHelper',
    component: () => import('@/views/service/serviceProvider/fans/FansHelper'),
    meta: {
      title: '粉丝助手',
      keepAlive: true
    }
  },
  {
    path: '/service/customTravel/book',
    name: 'BookList',
    component: () => import('@/views/service/serviceProvider/customTravel/BookList'),
    meta: {
      title: '预约列表',
      keepAlive: true
    }
  },
  {
    path: '/service/customTravel/list',
    name: 'CustomOrderList',
    component: () => import('@/views/service/serviceProvider/customTravel/CustomOrderList'),
    meta: {
      title: '订单管理',
      keepAlive: true
    }
  },
  {
    path: '/service/customTravel/new',
    name: 'NewOrders',
    component: () => import('@/views/service/serviceProvider/customTravel/NewOrders'),
    meta: {
      title: '新建定制游订单',
      keepAlive: true
    }
  },
  {
    path: '/service/customTravel/detail',
    name: 'CustomOrderDetails',
    component: () => import('@/views/service/serviceProvider/customTravel/CustomOrderDetails'),
    meta: {
      title: '订单详情',
      keepAlive: false
    }
  },
  {
    path: '/service/socialCommerce/setting',
    name: 'SocialSetting',
    component: () => import('@/views/service/serviceProvider/socialCommerce/SocialSetting'),
    meta: {
      title: '内容设置',
      keepAlive: false
    }
  },
  {
    path: '/service/socialCommerce/rule',
    name: 'SocialRule',
    component: () => import('@/views/service/serviceProvider/socialCommerce/SocialRule'),
    meta: {
      title: '佣金规则',
      keepAlive: false
    }
  },
  {
    path: '/service/ticketTenpay/pro',
    name: 'SyncTicketPro',
    component: () => import('@/views/service/serviceProvider/ticketTenpay/SyncTicketPro'),
    meta: {
      title: '同步商品',
      keepAlive: false
    }
  },
  {
    path: '/service/ticketTenpay/order',
    name: 'SyncTicketOrder',
    component: () => import('@/views/service/serviceProvider/ticketTenpay/SyncTicketOrder'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/ticketTenpay/account',
    name: 'RelAccount',
    component: () => import('@/views/service/serviceProvider/ticketTenpay/RelAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/ticketTenpay/rule',
    name: 'SyncRules',
    component: () => import('@/views/service/serviceProvider/ticketTenpay/SyncRules'),
    meta: {
      title: '同步规则',
      keepAlive: false
    }
  },
  {
    path: '/service/zhReward/pro',
    name: 'RewardBindPro',
    component: () => import('@/views/service/serviceProvider/zhReward/RewardBindPro'),
    meta: {
      title: '商品绑定',
      keepAlive: false
    }
  },
  {
    path: '/service/zhReward/order',
    name: 'zhRewardOrder',
    component: () => import('@/views/service/serviceProvider/zhReward/zhRewardOrder'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/zhReward/account',
    name: 'RelevanceAccount',
    component: () => import('@/views/service/serviceProvider/zhReward/RelevanceAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/socialGroup/set',
    name: 'MarketingSetting',
    component: () => import('@/views/service/serviceProvider/socialGroup/MarketingSetting'),
    meta: {
      title: '营销设置',
      keepAlive: false
    }
  },
  {
    path: '/service/tencentMarketing/sendMes',
    name: 'GroupSentMessage',
    component: () => import('@/views/service/serviceProvider/tencentMarketing/GroupSentMessage'),
    meta: {
      title: '群发消息',
      keepAlive: false
    }
  },
  {
    path: '/service/tencentMarketing/sendList',
    name: 'GroupSendList',
    component: () => import('@/views/service/serviceProvider/tencentMarketing/GroupSendList'),
    meta: {
      title: '群发记录',
      keepAlive: false
    }
  },
  {
    path: '/service/tencentMarketing/reply',
    name: 'AutoReplyList',
    component: () => import('@/views/service/serviceProvider/tencentMarketing/AutoReplyList'),
    meta: {
      title: '自动回复',
      keepAlive: false
    }
  },
  {
    path: '/service/tencentMarketing/rules',
    name: 'AutoReplyRules',
    component: () => import('@/views/service/serviceProvider/tencentMarketing/AutoReplyRules'),
    meta: {
      title: '自动回复规则',
      keepAlive: false
    }
  },
  {
    path: '/service/planeTickets/plane',
    name: 'PlaneTickets',
    component: () => import('@/views/service/serviceProvider/planeTickets/PlaneTickets'),
    meta: {
      title: '国内机票直连',
      keepAlive: false
    }
  },
  {
    path: '/service/groupBooking/goods',
    name: 'GroupServiceList',
    component: () => import('@/views/service/serviceProvider/groupBooking/GroupServiceList'),
    meta: {
      title: '拼团商品',
      keepAlive: true
    }
  },
  {
    path: '/service/groupBooking/new',
    name: 'NewGroup',
    component: () => import('@/views/service/serviceProvider/groupBooking/NewGroup'),
    meta: {
      title: '新建拼团',
      keepAlive: true
    }
  },
  {
    path: '/service/groupBooking/order',
    name: 'GroupOrderList',
    component: () => import('@/views/service/serviceProvider/groupBooking/GroupOrderList'),
    meta: {
      title: '拼团订单',
      keepAlive: true
    }
  },
  {
    path: '/service/groupBooking/detail',
    name: 'GroupOrderDetails',
    component: () => import('@/views/service/serviceProvider/groupBooking/GroupOrderDetails'),
    meta: {
      title: '拼团详情',
      keepAlive: true
    }
  },
  {
    path: '/service/advertising/list',
    name: 'AdvertisingList',
    component: () => import('@/views/service/serviceProvider/advertising/AdvertisingList'),
    meta: {
      title: '广告列表',
      keepAlive: false
    }
  },
  {
    path: '/service/advertising/stats',
    name: 'DataStatsList',
    component: () => import('@/views/service/serviceProvider/advertising/DataStatsList'),
    meta: {
      title: '数据统计',
      keepAlive: true
    }
  },
  {
    path: '/service/advertising/new',
    name: 'NewAdvertisiing',
    component: () => import('@/views/service/serviceProvider/advertising/NewAdvertisiing'),
    meta: {
      title: '添加广告',
      keepAlive: false
    }
  },
  //新人专享基础设置
  {
    path: '/service/newExclusive/basicSetting',
    name: 'BasicSetting',
    component: () => import('@/views/service/serviceProvider/newExclusive/BasicSetting'),
    meta: {
      title: '基础设置',
      keepAlive: false
    }
  },
  {
    path: '/service/newExclusive/bindCoupon',
    name: 'BindCoupon',
    component: () => import('@/views/service/serviceProvider/newExclusive/BindCoupon'),
    meta: {
      title: '优惠券关联',
      keepAlive: false
    }
  },
  {
    path: '/service/ydHotelDirect/accountSettings',
    name: 'AccountSettings',
    component: () => import('@/views/service/serviceProvider/ydHotelDirect/AccountSettings'),
    meta: {
      title: '账号设置',
      keepAlive: true
    }
  },
  {
    path: '/service/ydHotelDirect/priceRules',
    name: 'PriceRules',
    component: () => import('@/views/service/serviceProvider/ydHotelDirect/PriceRules'),
    meta: {
      title: '价格规则',
      keepAlive: true
    }
  },
  {
    path: '/service/trainTicket/tickets',
    name: 'TrainTickets',
    component: () => import('@/views/service/serviceProvider/trainTicket/TrainTickets'),
    meta: {
      title: '火车票设置',
      keepAlive: false
    }
  },
  {
    path: '/service/busTicket/bindBus',
    name: 'BusConnection',
    component: () => import('@/views/service/serviceProvider/busTicket/BusConnection'),
    meta: {
      title: '商品绑定',
      keepAlive: false
    }
  },
  {
    path: '/service/busTicket/pro',
    name: 'BusConnection',
    component: () => import('@/views/service/serviceProvider/busTicket/BusConnection'),
    meta: {
      title: '商品绑定',
      keepAlive: false
    }
  },
  {
    path: '/service/busTicket/order',
    name: 'BusOrderConnection',
    component: () => import('@/views/service/serviceProvider/busTicket/BusOrderConnection'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/busTicket/account',
    name: 'BusNewAccount',
    component: () => import('@/views/service/serviceProvider/busTicket/BusNewAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/galasysTicket/pro',
    name: 'GalasysConnection',
    component: () => import('@/views/service/serviceProvider/galasysTicket/GalasysConnection'),
    meta: {
      title: '商品绑定',
      keepAlive: false
    }
  },
  {
    path: '/service/galasysTicket/order',
    name: 'GalasysOrderConnection',
    component: () => import('@/views/service/serviceProvider/galasysTicket/GalasysOrderConnection'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/galasysTicket/account',
    name: 'GalasysNewAccount',
    component: () => import('@/views/service/serviceProvider/galasysTicket/GalasysNewAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/galasysTicket/rule',
    name: 'GalasysAsyncRule',
    component: () => import('@/views/service/serviceProvider/galasysTicket/GalasysAsyncRule'),
    meta: {
      title: '同步规则',
      keepAlive: false
    }
  },
  {
    path: '/service/goldenERP/productList',
    name: 'ProductList',
    component: () => import('@/views/service/serviceProvider/goldenERP/ProductList'),
    meta: {
      title: '金枫叶同步产品',
      keepAlive: false
    }
  },
  {
    path: '/service/goldenERP/accountList',
    name: 'AccountList',
    component: () => import('@/views/service/serviceProvider/goldenERP/AccountList'),
    meta: {
      title: '金枫叶关联账号',
      keepAlive: false
    }
  },

  {
    path: '/service/hotelRightsMember/list',
    name: 'HotelMemberList',
    component: () => import('@/views/service/serviceProvider/hotelRightsMember/HotelMemberList'),
    meta: {
      title: '权益列表',
      keepAlive: false
    }
  },
  {
    path: '/service/hotelRightsMember/newMember',
    name: 'NewHotelMember',
    component: () => import('@/views/service/serviceProvider/hotelRightsMember/NewHotelMember'),
    meta: {
      title: '权益设置',
      keepAlive: false
    }
  },
  {
    path: '/service/hotelRightsMember/info',
    name: 'HotelMemberInfo',
    component: () => import('@/views/service/serviceProvider/hotelRightsMember/HotelMemberInfo'),
    meta: {
      title: '基础信息',
      keepAlive: false
    }
  },
  {
    path: '/service/oto',
    name: 'OuTuService',
    component: () => import('@/views/service/serviceProvider/oto/OuTuService'),
    meta: {
      title: '偶途卡券直连',
      keepAlive: false
    }
  },
  {
    path: '/service/oto/linked/account',
    name: 'LinkedAccountList',
    component: () => import('@/views/service/serviceProvider/oto/LinkedAccountList'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },

  {
    path: '/service/gw/invitation/record',
    name: 'GuWeiInvitationRecord',
    component: () => import('@/views/service/serviceProvider/guWei/GuWeiInvitationRecord'),
    meta: {
      title: '好友邀请记录',
      keepAlive: false
    }
  },
  {
    path: '/service/gw/account/list',
    name: 'GuWeiAccount',
    component: () => import('@/views/service/serviceProvider/guWei/GuWeiAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/gw/policy',
    name: 'GuWeiPolicy',
    component: () => import('@/views/service/serviceProvider/guWei/GuWeiPolicy'),
    meta: {
      title: '防疫政策',
      keepAlive: false
    }
  },
  {
    path: '/service/gw/setting',
    name: 'GuWeiSetting',
    component: () => import('@/views/service/serviceProvider/guWei/GuWeiSetting'),
    meta: {
      title: '设置',
      keepAlive: false
    }
  }
]
